    <p-toast></p-toast>
    <app-page-shell>
      <app-page-hero eyebrow="HR Time" title="Time, Attendance, and Timesheets" subtitle="Capture attendance events, generate payroll-ready timesheets, resolve exceptions, and link time to logistics work.">
        <div actions>
          <button pButton type="button" icon="pi pi-refresh" label="Refresh" severity="secondary" [outlined]="true" (click)="load()" [disabled]="loading"></button>
        </div>
      </app-page-hero>

      @if (loading) {
        <p-progressBar mode="indeterminate"></p-progressBar>
      }

      <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

      <app-hr-list-tabs
        [tabs]="[
          { key: 'timesheets', label: 'Timesheets', icon: 'fa-solid fa-table-list', badge: timesheets.length },
          { key: 'exceptions', label: 'Attendance Exceptions', icon: 'fa-solid fa-triangle-exclamation', badge: exceptions.length },
          { key: 'events', label: 'Attendance Events', icon: 'fa-solid fa-clock', badge: events.length },
          { key: 'adjustments', label: 'Adjustment Queue', icon: 'fa-solid fa-pen-to-square', badge: adjustments.length }
        ]"
        [(activeTab)]="activeListTab"
      ></app-hr-list-tabs>

      <section class="time-top-grid">
        <app-hr-action-dialog [visible]="actionDialogVisible('event')" (visibleChange)="setActionDialogVisible('event', $event)" title="Record Attendance Event" eyebrow="Time Capture" subtitle="Capture a workforce punch with source, location, device, and logistics references." icon="fa-solid fa-clock" [contextTitle]="eventForm.employeeId ? 'Employee ' + eventForm.employeeId : 'New attendance event'" [contextSubtitle]="format(eventForm.eventType)">
        <app-page-form-section icon="fa-solid fa-clock" title="Record Attendance Event" subtitle="Capture web, manual, mobile, geofence, GPS, biometric API, or import events with logistics references.">
          <div class="form-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-id-badge"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="eventEmployeeId" [options]="employeeOptions" optionLabel="label" optionValue="value" [(ngModel)]="eventForm.employeeId" [filter]="true" filterBy="label" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                <label for="eventEmployeeId">Employee</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-stopwatch"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="eventType" [options]="eventTypeOptions" optionLabel="label" optionValue="value" [(ngModel)]="eventForm.eventType" styleClass="w-full"></p-select>
                <label for="eventType">Event type</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-calendar"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="eventTime" pInputText type="datetime-local" [(ngModel)]="eventForm.eventTime" />
                <label for="eventTime">Event time</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-satellite-dish"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="eventSource" [options]="sourceOptions" optionLabel="label" optionValue="value" [(ngModel)]="eventForm.source" styleClass="w-full"></p-select>
                <label for="eventSource">Source</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-location-dot"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="locationName" pInputText [(ngModel)]="eventForm.locationName" />
                <label for="locationName">Location/site</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-fingerprint"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="sourceReference" pInputText [(ngModel)]="eventForm.sourceReference" />
                <label for="sourceReference">Source reference</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-hard-drive"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="sourceDeviceId" pInputText [(ngModel)]="eventForm.sourceDeviceId" />
                <label for="sourceDeviceId">Device/source ID</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-truck-ramp-box"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="deliveryId" pInputText type="number" [(ngModel)]="eventForm.deliveryId" />
                <label for="deliveryId">Delivery ID</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-truck-moving"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="mobilizationId" pInputText type="number" [(ngModel)]="eventForm.mobilizationId" />
                <label for="mobilizationId">Mobilization ID</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-warehouse"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="warehouseId" pInputText type="number" [(ngModel)]="eventForm.warehouseId" />
                <label for="warehouseId">Warehouse ID</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup class="wide">
              <p-inputGroupAddon><i class="fa-solid fa-align-left"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <textarea id="eventNotes" pTextarea rows="3" [(ngModel)]="eventForm.notes"></textarea>
                <label for="eventNotes">Notes</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
          <div class="form-actions">
            <button pButton type="button" icon="fa-solid fa-plus" label="Record Event" (click)="recordEvent()" [disabled]="!canManageTime || !eventForm.employeeId || !eventForm.eventType || !eventForm.eventTime"></button>
            <button pButton type="button" icon="pi pi-undo" label="Reset" severity="secondary" [outlined]="true" (click)="resetEvent()"></button>
          </div>
        </app-page-form-section>
        </app-hr-action-dialog>

        <app-hr-action-dialog [visible]="actionDialogVisible('generation')" (visibleChange)="setActionDialogVisible('generation', $event)" title="Generate Timesheets" eyebrow="Timesheet Processing" subtitle="Build payroll-ready timesheets from paired attendance events and detect exceptions." icon="fa-solid fa-table-cells" contextTitle="Generation window" [contextSubtitle]="generationForm.periodStart && generationForm.periodEnd ? generationForm.periodStart + ' to ' + generationForm.periodEnd : 'Period required'">
        <app-page-form-section icon="fa-solid fa-table-cells" title="Generate Timesheets" subtitle="Build timesheets from paired attendance events and detect missing clock-outs or overtime exceptions.">
          <div class="form-grid small">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-calendar-day"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="periodStart" pInputText type="date" [(ngModel)]="generationForm.periodStart" />
                <label for="periodStart">Period start</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-calendar-check"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="periodEnd" pInputText type="date" [(ngModel)]="generationForm.periodEnd" />
                <label for="periodEnd">Period end</label>
              </p-iftaLabel>
            </p-inputGroup>

            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-id-badge"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="generationEmployeeId" [options]="employeeOptions" optionLabel="label" optionValue="value" [(ngModel)]="generationForm.employeeId" [filter]="true" filterBy="label" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                <label for="generationEmployeeId">Employee</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
          <div class="form-actions">
            <button pButton type="button" icon="fa-solid fa-gears" label="Generate" (click)="generateTimesheets()" [disabled]="!canManageTime || !generationForm.periodStart || !generationForm.periodEnd"></button>
            <button pButton type="button" icon="pi pi-undo" label="Reset" severity="secondary" [outlined]="true" (click)="resetGeneration()"></button>
          </div>

          <div class="time-rule-list">
            <span><i class="fa-solid fa-road"></i> Driver duty/drive/rest events</span>
            <span><i class="fa-solid fa-warehouse"></i> Warehouse/site references</span>
            <span><i class="fa-solid fa-file-invoice-dollar"></i> Payroll-ready inputs</span>
            <span><i class="fa-solid fa-lock"></i> Lock after payroll posting</span>
          </div>
        </app-page-form-section>
        </app-hr-action-dialog>
      </section>

      <section class="time-data-grid">
        <app-page-data-panel [hidden]="activeListTab !== 'timesheets'" title="Timesheets" subtitle="Submit, approve, and lock generated payroll-ready timesheets." [resultText]="timesheets.length + ' timesheets'">
          @if (canManageTime) {
            <div actions><button pButton type="button" icon="fa-solid fa-table-cells" label="Generate Timesheets" (click)="openActionDialog('generation')"></button></div>
          }
          <div class="filter-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-signal"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="timesheetStatusFilter" [options]="timesheetStatusOptions" optionLabel="label" optionValue="value" [showClear]="true" [(ngModel)]="timesheetFilters.status" styleClass="w-full"></p-select>
                <label for="timesheetStatusFilter">Status</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-id-badge"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="timesheetEmployeeFilter" [options]="employeeOptions" optionLabel="label" optionValue="value" [(ngModel)]="timesheetFilters.employeeId" [filter]="true" filterBy="label" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                <label for="timesheetEmployeeFilter">Employee</label>
              </p-iftaLabel>
            </p-inputGroup>
            <button pButton type="button" icon="pi pi-filter" label="Apply" (click)="loadTimesheets()"></button>
            <button pButton type="button" icon="pi pi-filter-slash" label="Clear" severity="secondary" [outlined]="true" (click)="clearTimesheetFilters()"></button>
          </div>

          <p-table [value]="timesheets" [loading]="loading" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '1260px' }" [paginator]="true" [rows]="15">
            <ng-template pTemplate="header">
              <tr><th>Employee</th><th>Period</th><th>Status</th><th>Regular</th><th>Overtime</th><th>Drive/Duty</th><th>Payroll</th><th style="width: 11rem">Actions</th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-timesheet>
              <tr>
                <td><strong>{{ timesheet.employeeName || '-' }}</strong><br><small>{{ timesheet.employeeNumber || timesheet.employeeId }}</small></td>
                <td>{{ timesheet.periodStart | date:'mediumDate' }}<br><small>{{ timesheet.periodEnd | date:'mediumDate' }}</small></td>
                <td><p-tag [value]="format(timesheet.timesheetStatus)" [severity]="timesheetSeverity(timesheet.timesheetStatus)"></p-tag></td>
                <td>{{ timesheet.regularHours ?? 0 }}</td>
                <td>{{ timesheet.overtimeHours ?? 0 }}</td>
                <td>{{ timesheet.driveDutyHours ?? 0 }}</td>
                <td>
                  <p-tag [value]="timesheet.payrollPosted ? 'Posted' : 'Prepared'" [severity]="timesheet.payrollPosted ? 'success' : 'info'"></p-tag>
                </td>
                <td>
                  <div class="row-actions">
                    <button pButton type="button" icon="pi pi-eye" [rounded]="true" [text]="true" (click)="openTimesheet(timesheet)"></button>
                    <button pButton type="button" icon="pi pi-send" [rounded]="true" [text]="true" (click)="submitTimesheet(timesheet)" [disabled]="!canManageTime || timesheet.timesheetStatus !== 'DRAFT'"></button>
                    <button pButton type="button" icon="pi pi-check" [rounded]="true" [text]="true" severity="success" (click)="approveTimesheet(timesheet)" [disabled]="!canApproveTime || timesheet.timesheetStatus !== 'SUBMITTED'"></button>
                    <button pButton type="button" icon="pi pi-lock" [rounded]="true" [text]="true" severity="warn" (click)="lockTimesheet(timesheet)" [disabled]="!canApproveTime || timesheet.timesheetStatus !== 'APPROVED'"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="8">No timesheets found.</td></tr>
            </ng-template>
          </p-table>
        </app-page-data-panel>

        <app-page-data-panel [hidden]="activeListTab !== 'exceptions'" title="Attendance Exceptions" subtitle="Resolve missing clock-outs, overtime thresholds, location mismatch, and manual adjustment exceptions." [resultText]="exceptions.length + ' exceptions'">
          <div class="filter-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-signal"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="exceptionStatusFilter" [options]="exceptionStatusOptions" optionLabel="label" optionValue="value" [showClear]="true" [(ngModel)]="exceptionStatus" styleClass="w-full"></p-select>
                <label for="exceptionStatusFilter">Exception status</label>
              </p-iftaLabel>
            </p-inputGroup>
            <button pButton type="button" icon="pi pi-filter" label="Apply" (click)="loadExceptions()"></button>
          </div>

          <p-table [value]="exceptions" [loading]="loading" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '980px' }" [paginator]="true" [rows]="12">
            <ng-template pTemplate="header">
              <tr><th>Employee</th><th>Type</th><th>Severity</th><th>Date</th><th>Description</th><th style="width: 5rem">Resolve</th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr>
                <td><strong>{{ row.employeeName || '-' }}</strong><br><small>{{ row.employeeNumber || row.employeeId }}</small></td>
                <td>{{ format(row.exceptionType) }}<br><small>{{ format(row.exceptionStatus) }}</small></td>
                <td><p-tag [value]="format(row.severity)" [severity]="row.severity === 'ERROR' ? 'danger' : 'warn'"></p-tag></td>
                <td>{{ row.eventDate | date:'mediumDate' }}</td>
                <td>{{ row.description || '-' }}</td>
                <td>
                  <button pButton type="button" icon="pi pi-check" [rounded]="true" [text]="true" severity="success" (click)="resolveException(row)" [disabled]="!canManageTime || row.exceptionStatus !== 'OPEN'"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="6">No attendance exceptions found.</td></tr>
            </ng-template>
          </p-table>
        </app-page-data-panel>
      </section>

      <section class="time-data-grid">
        <app-page-data-panel [hidden]="activeListTab !== 'events'" title="Recent Attendance Events" subtitle="Latest workforce time capture events with logistics references." [resultText]="events.length + ' events'">
          @if (canManageTime) {
            <div actions><button pButton type="button" icon="fa-solid fa-plus" label="Record Event" (click)="openActionDialog('event')"></button></div>
          }
          <p-table [value]="events" [loading]="loading" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '1080px' }">
            <ng-template pTemplate="header">
              <tr><th>Employee</th><th>Event</th><th>Time</th><th>Source</th><th>Location</th><th>References</th><th>Notes</th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-event>
              <tr>
                <td><strong>{{ event.employeeName || '-' }}</strong><br><small>{{ event.employeeNumber || event.employeeId }}</small></td>
                <td><p-tag [value]="format(event.eventType)" severity="info"></p-tag></td>
                <td>{{ event.eventTime | date:'short' }}</td>
                <td>{{ format(event.source) }}<br><small>{{ event.sourceReference || event.sourceDeviceId || '-' }}</small></td>
                <td>{{ event.locationName || '-' }}</td>
                <td>
                  <small>Delivery {{ event.deliveryId || '-' }}</small>
                  <small>Mobilization {{ event.mobilizationId || '-' }}</small>
                  <small>Warehouse {{ event.warehouseId || '-' }}</small>
                </td>
                <td>{{ event.notes || '-' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="7">No attendance events found.</td></tr>
            </ng-template>
          </p-table>
        </app-page-data-panel>

        <app-hr-action-dialog [visible]="actionDialogVisible('adjustment')" (visibleChange)="setActionDialogVisible('adjustment', $event)" title="Manual Adjustment Request" eyebrow="Audited Correction" subtitle="Submit a correction for approval before regenerated timesheets include it." icon="fa-solid fa-pen-to-square" [contextTitle]="adjustmentForm.employeeId ? 'Employee ' + adjustmentForm.employeeId : 'New adjustment'" [contextSubtitle]="adjustmentForm.eventDate || 'Event date required'">
        <app-page-form-section icon="fa-solid fa-pen-to-square" title="Manual Adjustment Request" subtitle="Submit audited corrections with a required reason and optional logistics references.">
          <div class="form-grid">
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-id-badge"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-select inputId="adjustEmployeeId" [options]="employeeOptions" optionLabel="label" optionValue="value" [(ngModel)]="adjustmentForm.employeeId" [filter]="true" filterBy="label" [showClear]="true" appendTo="body" styleClass="w-full"></p-select>
                <label for="adjustEmployeeId">Employee</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-sliders"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="adjustmentType" pInputText [(ngModel)]="adjustmentForm.adjustmentType" />
                <label for="adjustmentType">Adjustment type</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-calendar"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="adjustEventDate" pInputText type="date" [(ngModel)]="adjustmentForm.eventDate" />
                <label for="adjustEventDate">Event date</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-hourglass-half"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <p-inputNumber inputId="adjustHours" [(ngModel)]="adjustmentForm.hours" [minFractionDigits]="2" [maxFractionDigits]="2" styleClass="w-full"></p-inputNumber>
                <label for="adjustHours">Hours</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-play"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="adjustStartTime" pInputText type="datetime-local" [(ngModel)]="adjustmentForm.startTime" />
                <label for="adjustStartTime">Start time</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-stop"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="adjustEndTime" pInputText type="datetime-local" [(ngModel)]="adjustmentForm.endTime" />
                <label for="adjustEndTime">End time</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-truck-ramp-box"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="adjustDeliveryId" pInputText type="number" [(ngModel)]="adjustmentForm.deliveryId" />
                <label for="adjustDeliveryId">Delivery ID</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup>
              <p-inputGroupAddon><i class="fa-solid fa-truck-moving"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <input id="adjustMobilizationId" pInputText type="number" [(ngModel)]="adjustmentForm.mobilizationId" />
                <label for="adjustMobilizationId">Mobilization ID</label>
              </p-iftaLabel>
            </p-inputGroup>
            <p-inputGroup class="wide">
              <p-inputGroupAddon><i class="fa-solid fa-align-left"></i></p-inputGroupAddon>
              <p-iftaLabel>
                <textarea id="adjustReason" pTextarea rows="3" [(ngModel)]="adjustmentForm.reason"></textarea>
                <label for="adjustReason">Reason</label>
              </p-iftaLabel>
            </p-inputGroup>
          </div>
          <div class="form-actions">
            <button pButton type="button" icon="fa-solid fa-paper-plane" label="Submit Adjustment" (click)="requestAdjustment()" [disabled]="!canAdjustTime || !adjustmentForm.employeeId || !adjustmentForm.adjustmentType || !adjustmentForm.eventDate || !adjustmentForm.reason"></button>
            <button pButton type="button" icon="pi pi-undo" label="Reset" severity="secondary" [outlined]="true" (click)="resetAdjustment()"></button>
          </div>
        </app-page-form-section>
        </app-hr-action-dialog>
      </section>

      <app-page-data-panel [hidden]="activeListTab !== 'adjustments'" title="Time Adjustment Queue" subtitle="Approve or reject manual corrections before they are included in regenerated timesheets." [resultText]="adjustments.length + ' adjustments'">
        @if (canAdjustTime) {
          <div actions><button pButton type="button" icon="fa-solid fa-plus" label="Request Adjustment" (click)="openActionDialog('adjustment')"></button></div>
        }
        <div actions>
          <button pButton type="button" icon="pi pi-refresh" label="Refresh Queue" severity="secondary" [outlined]="true" (click)="loadAdjustments()"></button>
        </div>
        <p-table [value]="adjustments" [loading]="loading" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '1160px' }" [paginator]="true" [rows]="12">
          <ng-template pTemplate="header">
            <tr><th>Employee</th><th>Status</th><th>Type</th><th>Date/Window</th><th>Hours</th><th>References</th><th>Reason</th><th style="width: 7rem">Decision</th></tr>
          </ng-template>
          <ng-template pTemplate="body" let-adjustment>
            <tr>
              <td><strong>{{ adjustment.employeeName || '-' }}</strong><br><small>{{ adjustment.employeeNumber || adjustment.employeeId }}</small></td>
              <td><p-tag [value]="format(adjustment.requestStatus)" [severity]="adjustmentSeverity(adjustment.requestStatus)"></p-tag></td>
              <td>{{ format(adjustment.adjustmentType) }}</td>
              <td>{{ adjustment.eventDate | date:'mediumDate' }}<br><small>{{ adjustment.startTime | date:'short' }} - {{ adjustment.endTime | date:'short' }}</small></td>
              <td>{{ adjustment.hours ?? '-' }}</td>
              <td><small>D {{ adjustment.deliveryId || '-' }} · M {{ adjustment.mobilizationId || '-' }} · W {{ adjustment.warehouseId || '-' }}</small></td>
              <td>{{ adjustment.reason || '-' }}</td>
              <td>
                <div class="row-actions">
                  <button pButton type="button" icon="pi pi-check" [rounded]="true" [text]="true" severity="success" (click)="approveAdjustment(adjustment)" [disabled]="!canApproveTime || adjustment.requestStatus !== 'PENDING'"></button>
                  <button pButton type="button" icon="pi pi-times" [rounded]="true" [text]="true" severity="danger" (click)="rejectAdjustment(adjustment)" [disabled]="!canApproveTime || adjustment.requestStatus !== 'PENDING'"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="8">No time adjustment requests found.</td></tr>
          </ng-template>
        </p-table>
      </app-page-data-panel>
    </app-page-shell>

    <p-dialog
      header="Timesheet Detail"
      [(visible)]="timesheetDialogVisible"
      [modal]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: 'min(1080px, 96vw)' }">
      @if (selectedTimesheet) {
        <div class="timesheet-dialog">
          <div class="summary-grid">
            <div><span>Employee</span><strong>{{ selectedTimesheet.employeeName || '-' }}</strong><small>{{ selectedTimesheet.employeeNumber || selectedTimesheet.employeeId }}</small></div>
            <div><span>Period</span><strong>{{ selectedTimesheet.periodStart | date:'mediumDate' }}</strong><small>{{ selectedTimesheet.periodEnd | date:'mediumDate' }}</small></div>
            <div><span>Status</span><p-tag [value]="format(selectedTimesheet.timesheetStatus)" [severity]="timesheetSeverity(selectedTimesheet.timesheetStatus)"></p-tag><small>{{ selectedTimesheet.payrollPosted ? 'Payroll posted' : 'Payroll input prepared' }}</small></div>
            <div><span>Hours</span><strong>{{ selectedTimesheet.regularHours ?? 0 }} / {{ selectedTimesheet.overtimeHours ?? 0 }}</strong><small>Regular / overtime</small></div>
          </div>

          <p-table [value]="selectedTimesheet.lines || []" styleClass="p-datatable-sm" responsiveLayout="scroll" [tableStyle]="{ 'min-width': '920px' }">
            <ng-template pTemplate="header">
              <tr><th>Date</th><th>Type</th><th>Window</th><th>Regular</th><th>Overtime</th><th>Drive/Duty</th><th>Refs</th><th>Payroll Code</th></tr>
            </ng-template>
            <ng-template pTemplate="body" let-line>
              <tr>
                <td>{{ line.workDate | date:'mediumDate' }}</td>
                <td>{{ format(line.lineType) }}</td>
                <td>{{ line.startTime | date:'short' }}<br><small>{{ line.endTime | date:'short' }}</small></td>
                <td>{{ line.regularHours ?? 0 }}</td>
                <td>{{ line.overtimeHours ?? 0 }}</td>
                <td>{{ line.driveDutyHours ?? 0 }}</td>
                <td><small>D {{ line.deliveryId || '-' }} · M {{ line.mobilizationId || '-' }} · W {{ line.warehouseId || '-' }}</small></td>
                <td>{{ line.payrollInputCode || '-' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr><td colspan="8">This timesheet has no lines loaded.</td></tr>
            </ng-template>
          </p-table>

          @if (selectedTimesheet.payrollInputJson) {
            <pre>{{ prettyPayroll(selectedTimesheet.payrollInputJson) }}</pre>
          }
        </div>
      }
    </p-dialog>
